<template>
    <div class="w-full">
        <BreezeLabel
            v-if="label"
            :value="label"
            class="mb-1"
            :required="required"/>

        <div class="flex items-center space-x-2">
            <Multiselect
                v-bind="$attrs"
                autocomplete="off"
                :class="{classess}"
                class="mt-1"
                :required="required"
                :placeholder="placeholder"
                :label="labelKey"
                :trackBy="(trackKey==='id')?labelKey:trackKey"
                v-model="modelData"
                :valueProp="returnValue"
                :disabled="disabled"
                :object="object"
                :mode="mode"
                :searchable="searchable"
                :max="max"
                :canClear="canClear"
                :search-filter="searchOptions"
                :searchStart="searchStart"
                @change="emit('change',$event)"
                @input="emit('update:modelValue', $event);"
                :options="options">
                <template v-slot:singlelabel="{ value }">
                    <div class="multiselect-single-label">
                        <slot name="label" :item="value">
                            {{ value[labelKey] }}
                        </slot>
                    </div>
                </template>
                <!--                <slot/>-->
            </Multiselect>

        </div>
        <BreezeInputError :message="error"/>
    </div>
</template>

<script setup>
import BreezeLabel from '@/Components/Label';
import BreezeInputError from '@/Components/InputError'
import Multiselect from '@vueform/multiselect';
import {ref, watch} from "vue";


const props = defineProps({
    label: String,
    classess: String,
    required: Boolean,
    modelValue: [String, Number, Boolean, Array, Object],
    max: [Number],
    type: {
        type: String,
        default: 'text'
    },
    trackKey: {
        type: String,
        default: 'title'
    },
    labelKey: {
        type: String,
        default: 'title'
    },
    returnValue: {
        type: String,
        default: 'id'
    },
    placeholder: {
        type: String,
        default: 'Select'
    },
    disabled: {
        type: Boolean,
        default: false
    },

    canClear: {
        type: Boolean,
        default: true
    },
    object: {
        type: Boolean,
        default: false
    },
    searchStart: {
        type: Boolean,
        default: true
    },
    mode: {
        type: String,
        default: 'single'
    },
    searchable: {
        type: Boolean,
        default: true
    },
    error: String,
    options: {
        type: [Object, Array],
        default: []
    },


})
const emit = defineEmits(['update:modelValue', 'change']);

const modelData = ref(props.modelValue);
watch(() => props.modelValue, (_new, _old) => {
    modelData.value = _new;
})

function searchOptions(option, query, select$) {
    if (!query) return true;

    try {
        const pattern = new RegExp(query, 'i');
        return pattern.test(option[(props?.trackKey==='id')?props?.labelKey:props?.trackKey]);
    } catch (e) {
        return true;
    }
    // Create a regex pattern for the search term (case-insensitive)

}

</script>


<style src="@vueform/multiselect/themes/default.css"></style>
<style>
.is-open {
    z-index: 9999 !important;
}

.multiselect-placeholder {
    text-wrap: nowrap !important;
}

.multiselect-option:hover, .multiselect-option.is-pointed:hover {
    color: black !important;
}

.multiselect-tag {
    background: black !important;
}

.multiselect {
    padding-right: 50px;
    border: 1px solid #D1D5DB !important;
    min-height: 37px !important;
    border-radius: 6px !important;
}

.multiselect-wrapper {
    min-height: auto;
}

.multiselect-caret {
    left: 53px;
}

.multiselect-clear {
    right: -56px;
}

.multiselect-search,
.multiselect-search:focus,
.multiselect-search:hover,
.multiselect-search:focus-within,
.multiselect-search:focus-visible {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
}

.multiselect-option.is-selected.is-pointed,
.multiselect-option.is-selected {
    color: white !important;
    background: #2f3846;
}

.multiselect-option:hover, .multiselect-option.is-pointed:hover {
    color: white !important;
    background: #2f3846;
}

.multiselect-single-label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.multiselect.is-active {
    box-shadow: none;
    border: 2px solid black;
    outline: 2px solid black !important;

}

.multiselect {
    box-shadow: none;
    border: 1px solid rgb(78 77 77);
}

.multiselect-dropdown {
    border-top: 2px solid #d2d5da !important;
    border: 2px solid black;
}

</style>

<!--<style>-->
<!--.is-open {-->
<!--    z-index: 99 !important;-->
<!--}-->

<!--.multiselect-placeholder {-->
<!--    text-wrap: nowrap !important;-->
<!--}-->

<!--.multiselect-option:hover, .multiselect-option.is-pointed:hover {-->
<!--    color: #D1D5DB !important;-->
<!--}-->

<!--.multiselect-tag {-->
<!--    background: #D1D5DB !important;-->
<!--}-->

<!--.multiselect {-->
<!--    padding-right: 50px;-->
<!--}-->

<!--.multiselect-caret {-->
<!--    left: 53px;-->
<!--}-->

<!--.multiselect-clear {-->
<!--    right: -56px;-->
<!--}-->

<!--.multiselect-search,-->
<!--.multiselect-search:focus,-->
<!--.multiselect-search:hover,-->
<!--.multiselect-search:focus-within,-->
<!--.multiselect-search:focus-visible {-->
<!--    border: none !important;-->
<!--    outline: none !important;-->
<!--    box-shadow: none !important;-->
<!--}-->

<!--.multiselect-option.is-selected.is-pointed,-->
<!--.multiselect-option.is-selected {-->
<!--    color: white !important;-->
<!--    background: #212936;-->
<!--}-->

<!--.multiselect-option:hover, .multiselect-option.is-pointed:hover {-->
<!--    color: white !important;-->
<!--    background: #2f3846;-->
<!--}-->

<!--.multiselect-single-label {-->
<!--    white-space: nowrap;-->
<!--    overflow: hidden;-->
<!--    text-overflow: ellipsis;-->
<!--}-->

<!--.multiselect.is-active {-->
<!--    box-shadow: none;-->
<!--    border: 2px solid #D1D5DB;-->
<!--}-->

<!--.multiselect {-->
<!--    box-shadow: none;-->
<!--    border: 2px solid #d2d5da;-->
<!--}-->

<!--.multiselect-dropdown {-->
<!--    border-top: 2px solid #d2d5da !important;-->
<!--    border: 2px solid #D1D5DB;-->
<!--}-->

<!--</style>-->
